export default ({ request }) => ({
  ecomAmzFtyPurchaseListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailAddApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/add',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailUpdateApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/update',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseBatchListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/batch/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseBatchSelectTotalApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/batch/selectTotal',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseBatchSkuListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/batch/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSampleListingApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/sample/listing',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSampleListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/sample/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSampleSetApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/sample/set',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseSendContractApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/sendContract',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseBatchCreateOrderApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/batchCreateOrder',
      method: 'POST',
      data,
      timeout: 1000 * 60 * 5,
    })
  },
})
